<div class="logo-container">
  <div *ngIf="!logoUrl" class="upload-container" (click)="selectFile()">
    <img src="../../assets/icons/icon-img.svg" alt="Imagem" />
    <h6 class="upload-title">Adicionar logo</h6>
    <p class="upload-info" [ngClass]="{ error: error }">
      <i *ngIf="error" class="bi bi-exclamation-circle"></i>
      <span>Tamanho máximo de {{ maxFileSizeMB }}mb</span>
    </p>
  </div>

  <div *ngIf="logoUrl" class="image-container">
    <img [src]="logoUrl" alt="Logo" />
    <button
      class="btn delete"
      data-testid="remove-image"
      (click)="removeLogo()"
    >
      <i class="bi bi-trash-fill"></i>
    </button>
  </div>
</div>
<input
  #inputUpload
  type="file"
  accept="image/*"
  hidden
  (change)="uploadFile($event)"
  data-testid="upload-image"
/>
